<div
  class="relative border border-dc-navy px-6 py-6 text-dc-navy dc-card-stretch"
  [ngClass]="{ 'inactive-card': !!owner?.endDate }"
>
  <!-- Member Details -->
  <div class="space-y-4 dc-card-stretch-body">
    <!-- Green check icon -->
    <div class="flex mb-1">
      <span>
        <!-- <i
        class="status-icon fa-solid fa-circle-check h-5 w-5 text-dc-dark-green"
        [ngClass]="{
          'fa-warning text-dc-orange': owner?.isError,
          'text-gray-400': !owner?.isError && owner?.endDate,
          'text-dc-dark-green': !owner?.isError && !owner?.endDate
        }"
       ></i> -->
        <img [src]="iconPath" class="status-icon" />
      </span>
      @if(owner?.isError){
      <span class="text-dc-orange">
        {{ "VALIDATION_MSG.FILL_REQUIRED_FIELDS" | translate }}
      </span>
      }
    </div>

    <!-- Owner Info -->
    <div class="mb-4 space-y-4">
      <!-- <h2>{{ owner.nameEn ? owner.nameEn : owner.companyNameEn }}</h2> -->
      <div class="text-dc-navy min-h-10">
        <h2 class="text-2xl font-semibold">
          {{ owner.nameEn ? owner.nameEn : owner.companyNameEn }}
        </h2>
        <label class="mb-1">{{ getLookupsNames("roles", owner.roles) }}</label>
      </div>

      <div class="dc-card-field">
        <span class="dc-card-field-label">{{
          "OWNER_FORM.NATIONALITY" | translate
        }}</span>
        <span class="dc-card-field-value">{{ owner.nationality }}</span>
      </div>

      <div class="dc-card-field">
        <span class="dc-card-field-label">{{
          "OWNER_FORM.MOBILE" | translate
        }}</span>
        <span class="dc-card-field-value">{{ owner.mobile }}</span>
      </div>

      <div class="dc-card-field">
        <span class="dc-card-field-label">{{
          "OWNER_FORM.EMAIL" | translate
        }}</span>
        <span class="dc-card-field-value">{{ owner.email }}</span>
      </div>
      <!-- @if(owner.endDate){
    <label>{{ "OWNER_FORM.END_DATE" | translate }}</label>
    <span>{{ owner.endDate | date : "dd-MMM-yyyy"  }}</span>
    } -->
    </div>

    <!-- Actions -->
    <div class="dc-card-stretch-actions">
      <div class="flex items-center gap-4 text-sm mt-7">
        @if(showAction){ @if(!owner.endDate){
        <a class="card-action-edit-remove" (click)="editDetail(owner)">
          {{ "EDIT_DETAILS" | translate }}
        </a>
        }
        <a
          class="card-action-edit-remove"
          (click)="owner?.endDate ? activate(owner) : remove(owner)"
        >
          {{
            owner?.endDate
              ? ("BUTTONS.ACTIVATE" | translate)
              : ("REMOVE" | translate)
          }}
        </a>
        }@else {
        <a class="card-action-edit-remove" (click)="editDetail(owner)">
          {{ "BUTTONS.VIEW_DETAILS" | translate }}
        </a>
        }
      </div>
    </div>
  </div>
  <!-- Bottom green corner -->
  <div
    [ngClass]="
      owner?.isError
        ? 'corner-accent dc-card-corner-red'
        : owner?.endDate
        ? 'corner-accent dc-card-corner-green'
        : 'corner-accent dc-card-corner-green'
    "
  ></div>
</div>
